import {
  USER_LOGIN_FAIL,
  USER_LOGIN_REQUEST,
  USER_LOGIN_SUCCESS,
  USER_LOGOUT,
  USER_DETAILS_REQUEST,
  USER_DETAILS_SUCCESS,
  USER_DETAILS_FAIL,
  USER_CHANGE_PASSWORD_REQUEST,
  USER_CHANGE_PASSWORD_SUCCESS,
  USER_CHANGE_PASSWORD_FAIL,
  USER_DETAILS_RESET,
  USER_FORGOT_FAIL,
  USER_FORGOT_REQUEST,
  USER_FORGOT_SUCCESS,
  USER_RESET_FAIL,
  USER_RESET_REQUEST,
  USER_RESET_SUCCESS,
  CUSTOMER_DETAILS_REQUEST,
  CUSTOMER_DETAILS_SUCCESS,
  CUSTOMER_DETAILS_FAIL,
  CUSTOMER_DETAILS_RESET,
} from "./userTypes";

export const userStateReducer = (state = {}, action) => {
  switch (action.type) {
    case USER_LOGIN_REQUEST || USER_DETAILS_REQUEST || USER_CHANGE_PASSWORD_REQUEST:
      return { ...state, loading: true };

    case USER_LOGIN_SUCCESS:
      return { ...state, loading: false, userInfo: action.payload };

    case USER_CHANGE_PASSWORD_SUCCESS:
      return { ...state, loading: false, message: action.payload.message };

    case USER_FORGOT_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case USER_FORGOT_SUCCESS:
      return {
        ...state,
        loading: false,
        forgotmessage: action.payload,
        error: "",
      };
    case USER_FORGOT_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
        forgotmessage: "",
      };

    case USER_RESET_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case USER_RESET_SUCCESS:
      return {
        ...state,
        loading: false,
        message: action.payload,
        error: "",
      };
    case USER_RESET_FAIL:
      return {
        ...state,
        loading: false,
        message: "",
        error: action.payload,
      };

    case CUSTOMER_DETAILS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case CUSTOMER_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        customer: action.payload.customer,
        customerOrders: action.payload.orders,
      };
    case CUSTOMER_DETAILS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CUSTOMER_DETAILS_RESET:
      return {
        ...state,
        loading: false,
        customer: null,
        customerOrders: null,
      };
    case USER_DETAILS_SUCCESS:
      return { ...state, loading: false, userData: action.payload };

    case USER_LOGIN_FAIL || USER_DETAILS_FAIL || USER_CHANGE_PASSWORD_FAIL:
      return { ...state, loading: false, error: action.payload };
    case USER_LOGOUT:
      return {};
    default:
      return state;
  }
};
